<template><div class="cruise-info">

    <div class="cruise-info__main">
        <MySlider class="cruise-info__slider" :slideRatio="190 / 280"
            :slides="headPhotos" srcKey="src_next" idKey="id"
         />

        <div class="cruise-info__content">
            <router-link :to="cruise_link" target="_blank"  class="cruise-info__title">{{beautifulName}}</router-link>

            <CruiseDates :dates="dates" />

            <ShipHead :ship="shipHead" />

        </div>

        <div class="cruise-info__route">
            <div class="cruise-info__route-title">Полный маршрут:</div>
            <div class="cruise-info__route-cities">{{routeFormatted}}</div>
        </div>

        <div class="cruise-info__sku-ids">{{cruiseIdString}} проверено {{checkedH}}</div>

    </div>

    <div class="cruise-info__booking">

        <div class="cruise-info__price-min">
            <template v-if="min_price.is">от <PriceCurrencyV  :price="min_price" :sum="true" /></template>
        </div>

        <div v-if="isKlk" class="klkmark"><KlkIcon class="kicon vicon-grey" />Возможна оплата баллами</div>

        <div class="cruise-info__available">

            <div class="cruise-info__suggestion">
                <template v-if="freeCabins">
                    <template v-if="hideFree(shipId)">Свободные каюты есть</template>
                    <template v-else>{{HaveLeftCabin(freeCabins)}}</template>
                </template>
                <template v-else>
                    Свободных кают нет
                </template>
            </div>

            <div v-if="min_price.is" class="cruise-info__option">
                <div class="cruise-info__option-name">за человека</div>
                <div class="cruise-info__option-price">
                    от <PriceCurrencyV :price="min_price" :sum="true" />
                </div>
            </div>

        </div>

        <router-link :to="cruise_link" class="btn btn--bluefigma" target="_blank">
            Выбрать каюту
        </router-link>


    </div>

</div></template>

<!--
вместо 
    style src="./CruiseInList.scss" 
import './CruiseInList.scss'

Используется в Layout.vue
Cделано чтобы стили не попадали в сборку дважды, но были в компоненте
-->

<script setup>
import './CruiseInList.scss' // чтобы стили не попадали в сборку дважды 

import useCruise from "@/comp/useCruise.js"
import {ref, computed} from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'    
import PriceCurrencyV from '@/comp/CruiseHead/PriceCurrencyV.vue'
import KlkIcon from '@/assets/vicons/klk.vue'
import { HaveLeftCabin } from '@/util.js'
import MySlider from '@/comp/MySlider/MySlider.vue'
import ShipHead from '@/comp/CruiseHead/ShipHead.vue'
import CruiseDates from '@/comp/CruiseHead/CruiseDates.vue'

const props = defineProps({
  cruise: Object, 
  noprice: Boolean,
  retq: Object,
})

const router = useRouter()

const { 
    beautifulName, route, min_price,

    photoMain, // is src

    freeCabins, cruiseId, checkedH, cruiseIdFull,  shipId, shipName,
    dateStartOb, dateEndOb, is_cruise_time_published,
    days, nights, cruiseIdString, isKlk,
    ship_link, cruise_link:cruise_link_base, cruise_tt_link: cruise_tt_link_base,
    shipStar, shipCompany, headPhotos, shipHead, dates,
} = useCruise(props.cruise)


const hideFree = (shipId) => {
    return 8 == shipId // AstoriaGrande - попросили скрыть
}

const routeFormatted = computed(() => {
    return route?.replace(/\s-\s/g, ' — ') || ''
})

const cruise_link = computed( () => {
    let ret = {...cruise_link_base}
    if (props.retq) {
        ret.query = { ...ret.query, ...props.retq  }
    }
    return ret
})
const cruise_tt_link = computed( () => {
    let ret = {...cruise_tt_link_base}
    if (props.retq) {
        ret.query = { ...ret.query, ...props.retq  }
    }
    return ret
})
</script>
